export const removeDuplicatesFromArray = (array, removeKey = 'id') => {
  const uniqueArray = array?.filter(
    (obj, index, self) =>
      index === self?.findIndex(t => t[removeKey] === obj[removeKey])
  )

  return uniqueArray
}
